import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import WireMatchHeader from '../common/wire-match-header';
import Wire from '../common/wire';
import ListedCompanyResultsContext from './context';
import useScrollableWires from '../common/scrollable-wires-hooks';
import Tail from '../common/wires-list-tail';
import useGetWiresMentioningStockCode from '../../../services/wires/mentioning-stock-code-service';

export default function WiresMentioning({ stockCode }) {
  const { dispatch } = React.useContext(ListedCompanyResultsContext);
  const {
    loading, infiniteRef, wires, rawData, expandList, total, showExpand, hasMore,
  } = useScrollableWires({
    isScrollable: false,
    initNumber: 20,
    useGetWires: () => useGetWiresMentioningStockCode(stockCode.slug),
  });

  React.useEffect(() => {
    dispatch({
      type: 'setLoadingWiresMentioning',
      // eslint-disable-next-line no-nested-ternary
      payload: !loading ? null : (wires.length ? 'more' : 'init'),
    });
  }, [loading, dispatch, wires.length]);

  React.useEffect(() => {
    if (_.get(rawData, 'wires.length')) {
      dispatch({ type: 'setWiresMentioning', payload: rawData.wires });
    }
  }, [rawData, dispatch]);

  return (
    <>
      {!!wires.length && (
        <article>
          <WireMatchHeader query={stockCode.companyName} text="mentioning" n={total} />
          {wires.map((wire, index) => <Wire bordered={false} key={`wires-mentioning-${wire.id}`} wire={wire} position={index + 1} />)}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all results</button></Tail>
          )}
          {!hasMore && <Tail><span>You have seen all the results</span></Tail>}
        </article>
      )}
    </>
  );
}

WiresMentioning.propTypes = {
  stockCode: PropTypes.shape({
    stockExchange: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
